import { FC } from 'react';

import VSpacing from 'bloko/blocks/vSpacing';

import SeoPagination from 'src/components/Pagination/SeoPagination';
import { SearchCatalogListByLetter } from 'src/models/searchCatalogList';
import CatalogLinks from 'src/pages/SearchCatalogList/components/CatalogLinks';
import LetterLinks from 'src/pages/SearchCatalogList/components/LetterLinks';

const ContentByLetter: FC<SearchCatalogListByLetter> = ({ catalogType, letters, catalogs, seoPaging }) => {
    return (
        <>
            <LetterLinks catalogType={catalogType} letters={letters} />
            <VSpacing base={3} />
            <CatalogLinks catalogs={catalogs} />
            {seoPaging && (
                <>
                    <VSpacing base={4} xs={2} />
                    <SeoPagination {...seoPaging} />
                </>
            )}
        </>
    );
};

export default ContentByLetter;
